import { Component, Inject, OnInit } from '@angular/core';
import { ProfileModel } from '../../../models/profile.model';
import { ProfileService } from '../../../../provider/profile.service';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'kt-profile-edit',
  templateUrl: './profile-edit.popup.html',
  styleUrls: ['./profile-edit.popup.scss']
})
export class ProfileEditPopup implements OnInit {
  profile: ProfileModel;

  password: string = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private myService: ProfileService,
    private router: Router) {
  }

  ngOnInit() {
    this.profile = this.data.data;
  }

  updateDate(value: string, key: string) {
    this.profile[key] = new Date(value);
  }

  updateProfile() {
    this.profile.date_of_birth = new Date(this.profile.date_of_birth);
    this.profile.release_date = new Date(this.profile.release_date);
    this.profile.entry_date = new Date(this.profile.entry_date);
    this.profile.booking_date = new Date(this.profile.booking_date);

    if (this.password) {
      this.profile.password = this.password;
    } else {
      delete this.profile.password;
    }

    this.myService.putProfile(this.profile);
    this.router.navigateByUrl('/activity/profiles').then();
  }
}
